import axiosInstance from '@/setup/axios/axiosInstance'
import {RoleModel, RoleResponse, CreateRoleRequest, UpdateRoleRequest} from '../models/Role'

export const normalizeRolesPayload = (payload: RoleResponse | RoleModel[] | undefined | null): RoleModel[] => {
  if (Array.isArray(payload)) {
    return payload
  }

  if (payload && Array.isArray(payload.results)) {
    return payload.results
  }

  return []
}

// Get all roles
export function getRoles() {
  return axiosInstance.get<RoleResponse | RoleModel[]>('/accounts/roles/', {
    params: {
      no_pagination: true,
    },
  })
}

// Get single role by ID
export function getRole(id: string) {
  return axiosInstance.get<RoleModel>(`/accounts/roles/${id}/`)
}

// Create new role
export function createRole(roleData: CreateRoleRequest) {
  return axiosInstance.post<RoleModel>('/accounts/roles/', roleData)
}

// Update role
export function updateRole(id: string, roleData: UpdateRoleRequest) {
  return axiosInstance.patch<RoleModel>(`/accounts/roles/${id}/`, roleData)
}

// Delete role
export function deleteRole(id: string) {
  return axiosInstance.delete(`/accounts/roles/${id}/`)
}

// Get available roles
export function getAvailableRoles() {
  return axiosInstance.get<RoleModel[]>('/accounts/roles/available/')
}

// Get groups of role
export function getRoleGroups(id: string) {
  return axiosInstance.get(`/accounts/roles/${id}/groups/`)
}













